// components/modals/AddArticlesModal.jsx
import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useCreateArticleMutation, useUpdateArticleMutation } from "../api/api"; // adjust import to your barrel path
import { getApiErrorMessage } from "../api/errorUtils";

const AddArticlesModal = ({
  modalOpen,
  toggleModal,
  addNewItem,
  editItemData,
  setEditItemData,
  tableData,
  setTableData,
  notificationMessage,
}) => {
  const [formData, setFormData] = useState({ name: "", article_id: "" });

  const [createArticle, { isLoading: creating }] = useCreateArticleMutation();
  const [updateArticle, { isLoading: updating }] = useUpdateArticleMutation();

  useEffect(() => {
    if (editItemData?.id) {
      setFormData({
        name: editItemData.name || "",
        article_id: editItemData.article_id || "",
      });
    } else {
      setFormData({ name: "", article_id: "" });
    }
  }, [editItemData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      if (editItemData?.id) {
        const payload = { id: editItemData.id, ...formData };
        const res = await updateArticle(payload).unwrap();
        // Your API shape looked like { success, data }
        if (res?.success) {
          const updated = tableData.map((it) =>
            it.id === editItemData.id ? { ...it, ...formData } : it
          );
          setTableData(updated);
          notificationMessage("success", "Article Item updated successfully");
          setEditItemData({});
          setFormData({ name: "", article_id: "" });
        } else {
          notificationMessage("danger", "Error updating article data");
        }
      } else {
        const res = await createArticle(formData).unwrap();
        if (res?.success) {
          // Assuming res.data is the new ID (as in your current code)
          addNewItem({
            id: res.data,
            article_id: formData.article_id,
            name: formData.name,
            quantity: 0,
          });
          setFormData({ name: "", article_id: "" });
        } else {
          notificationMessage("danger", "Error creating article");
        }
      }
      toggleModal("articles"); // keep your existing signature
    } catch (err) {
      console.error(err);
      notificationMessage(
        "danger",
        getApiErrorMessage(err, "Error saving article data", {
          403: "Only company managers, admins, or owners can manage administration articles.",
          404: "That administration article no longer exists in your company scope.",
          409: "This administration article conflicts with existing data.",
        })
      );
    }
  };

  return (
    <Modal
      className="record-sale-modal"
      isOpen={modalOpen}
      toggle={toggleModal}
    >
      <ModalHeader toggle={toggleModal}>
        {editItemData?.id ? "Edit Article" : "Add Articles"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="name">Article Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter Article Name"
              disabled={creating || updating}
            />
          </FormGroup>
          <FormGroup>
            <Label for="article_id">Administration Number</Label>
            <Input
              type="text"
              name="article_id"
              id="article_id"
              value={formData.article_id}
              onChange={handleInputChange}
              placeholder="Enter Administration Number"
              disabled={creating || updating}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={creating || updating}
        >
          {editItemData?.id
            ? updating
              ? "Saving..."
              : "Save"
            : creating
            ? "Saving..."
            : "Save"}
        </Button>
        <Button
          color="secondary"
          onClick={toggleModal}
          disabled={creating || updating}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddArticlesModal;
